import { IGioHocRangBuoc } from "../../../model/respone/category/IGioHocRangBuoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eGioHocRangBuocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IGioHocRangBuoc[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IGioHocRangBuoc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IGioHocRangBuoc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eGioHocRangBuocActionIds = generateActionTypeIds(eGioHocRangBuocActionsObj, "GIO_HOC_RANG_BUOC");
export type IGioHocRangBuocActionTypes = IGenericActionType<typeof eGioHocRangBuocActionsObj, "GIO_HOC_RANG_BUOC">;
